export default __webpack_public_path__ + "static/media/Raider's Leggings of World's Edge.d3fa4bc9.jpg";